import { createSelector } from 'reselect';
var selectAppGlobalDataState = function (_a) {
    var appGlobalData = _a.appGlobalData;
    return appGlobalData;
};
/**
 * Selects the selected criteria of the state
 */
export var appGlobalDataSelectedCriteriaSelector = createSelector(selectAppGlobalDataState, function (_a) {
    var selectedCriteria = _a.selectedCriteria;
    return selectedCriteria;
});
/**
 * Selects the selected newsgroup of the state
 */
export var appGlobalDataSelectedNewsGroupSelector = createSelector(selectAppGlobalDataState, function (_a) {
    var selectedNewsGroup = _a.selectedNewsGroup;
    return selectedNewsGroup;
});
/**
 * Selects the selected date of the state
 */
export var appGlobalDataSelectedDateSelector = createSelector(selectAppGlobalDataState, function (_a) {
    var selectedDate = _a.selectedDate;
    return selectedDate;
});
